module.exports = __webpack_public_path__ + "img/UTCORA-1.cf7395a1.jpg";